import AbstractModel from './AbstractModel'
import Mapper from './mapper/Mapper'
import Column from './table/Column'
import SelectColumn from './table/SelectColumn'
import DateColumn from './table/DateColumn'

class Aziende extends AbstractModel {
  permission () {
    return {
      'USR': {
        action: { isInsertable: false, isEditable: true, isDeletable: false },
        columns: {
          codcli: { onEditDisabled: true },
          idcat: { onEditDisabled: true },
          ragsoc: { onEditDisabled: true },
          indiri: { onEditDisabled: true },
          cap: { onEditDisabled: true },
          locali: { onEditDisabled: true },
          provi: { onEditDisabled: true },
          codfis: { onEditDisabled: true },
          pariva: { onEditDisabled: true },
          email: { onEditDisabled: true },
          email_aggiuntiva: { onEditDisabled: true },
          pec: { onEditDisabled: true },
          telefo: { onEditDisabled: true },
          fax: { onEditDisabled: true },
          titolare: { onEditDisabled: true },
          codice_abbinamento: { onEditDisabled: true },
          resphaccp: { onEditDisabled: true },
          password: { onEditDisabled: true },
          dataattiv: { onEditDisabled: true },
          hdatinizio: { onEditDisabled: true },
          hdatsca: { onEditDisabled: true },
          sdatinizio: { onEditDisabled: true },
          sdatsca: { onEditDisabled: true },
          pdatinizio: { onEditDisabled: true },
          pdatsca: { onEditDisabled: true },
          ndatinizio: { onEditDisabled: true },
          ndatsca: { onEditDisabled: true },
          gdpr: { onEditDisabled: true },
          gdpr_settori: { onEditDisabled: true },
          codice_collaboratore: { onEditDisabled: true },
          gdpr_capogruppo: { onEditDisabled: true },
          data_inizio_autocontrollo: { onEditDisabled: true },
          username: { isVisible: false, isEditable: false }
        }
      },
      'ADM': {
        action: { isImpersonate: true, isInsertable: true, isEditable: true, isDeletable: true, isClonable: true },
        columns: {}
      }
    }
  }
  mapper () {
    return [
      Mapper.column.azienda(false)
    ]
  }
  columns () {
    return [
      new Column('btn').withHtml(true).withWidth('100px').withIsEditable(false).withIsInsertable(false).withExportable(false),
      new Column('id').withType('number').withIsEditable(false).withIsInsertable(false).withIsVisible(false),
      new Column('codcli').withType('text').withIsTitle(true),
      new SelectColumn('idcat', Mapper.select.categoria()).withType('number'),
      new Column('ragsoc').withType('text').withWidth('300px'),
      new Column('indiri').withType('text'),
      new Column('cap').withType('number'),
      new Column('locali').withType('text'),
      new Column('provi').withType('text'),
      new Column('codfis').withType('text'),
      new Column('pariva').withType('text'),
      new Column('email').withType('email'),
      new Column('email_aggiuntiva').withType('email'),
      new Column('pec').withType('email'),
      new Column('telefo').withType('tel'),
      new Column('fax').withType('tel'),
      new Column('titolare').withType('text'),
      new Column('codice_abbinamento').withType('text').withIsEditable(false).withIsVisible(false).withIsInsertable(false),
      new SelectColumn('resphaccp', Mapper.select.collaboratore('aziende')).withType('text').withIsInsertable(false),
      new Column('username').withType('text'),
      new Column('password').withType('password').withIsEditable(false).withIsVisible(false).withIsInsertable(true),
      new DateColumn('dataattiv'),
      new DateColumn('hdatinizio').withIsEditable(false).withIsVisible(false).withIsInsertable(false),
      new DateColumn('hdatsca'),
      new DateColumn('sdatinizio'),
      new DateColumn('sdatsca'),
      new DateColumn('pdatinizio'),
      new DateColumn('pdatsca'),
      new DateColumn('ndatinizio'),
      new DateColumn('ndatsca'),
      new Column('gdpr').withType('boolean').withHtmlType('switch').withIsEditable(false).withIsVisible(false).withIsInsertable(false),
      new Column('gdpr_settori').withType('boolean').withIsEditable(false).withIsVisible(false).withIsInsertable(false),
      new Column('codice_collaboratore').withType('number').withIsEditable(false).withIsVisible(false).withIsInsertable(false),
      new Column('gdpr_capogruppo').withType('boolean').withHtmlType('switch').withIsEditable(false).withIsVisible(false).withIsInsertable(false),
      new DateColumn('data_inizio_autocontrollo').withIsEditable(false).withIsVisible(false).withIsInsertable(false)
    ]
  }

  validator () {
    return {
      codcli: { required: true, type: 'string' },
      cap: { required: true, type: 'string' },
      dataattiv: { required: true },
      Hdatsca: { required: true },
      Sdatinizio: { required: true },
      Sdatsca: { required: true },
      Pdatinizio: { required: true },
      Ndatinizio: { required: true },
      Ndatsca: { required: true },
      username: { required: true },
      password: { required: true },
      data_inizio_autocontrollo: { required: true },
      email_aggiuntiva: { required: true, pattern: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/igm, trigger: 'blur', message: 'Valore non corretto' },
      email: { required: true, pattern: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/igm, trigger: 'blur', message: 'Valore non corretto' },
      pec: { required: true, pattern: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/igm, trigger: 'blur', message: 'Valore non corretto' },
      telefo: { required: true, type: 'string', message: 'Valore non corretto', trigger: 'blur' },
      fax: { required: true, type: 'string', message: 'Valore non corretto', trigger: 'blur' }
    }
  }
}

export default new Aziende()
